import { useQuery } from "@tanstack/react-query";
import autoMessageService from "..";

const useGetCustomerNotifier = () =>
  useQuery({
    queryKey: ["getCustomerNotifier"],
    queryFn: () => autoMessageService.getAutoMessageConfig(),
    select: (res) => res,
  });

export { useGetCustomerNotifier };
